import formatearFecha from "@/mixins/formatearFecha";
import axios from "axios";

const calcularFechaInicial = () => {
  const today = new Date();
  let fecha = new Date(today.getFullYear(), today.getMonth(), 2);
  fecha = fecha.toISOString().substr(0, 10);
  // this.fechaAsientoFormateada = this.formatDate(this.fechaAsiento);
  return fecha;
};
const defaultFilters = {
  fechaInicio: calcularFechaInicial(),
  fechaFin: null,
  clienteSeleccionado: "",
  tecnicoSeleccionado: "",
  bloqueadas: false,

  mostrarAcciones: true,
  filtroEstadoParte: [],
  filtroTipoAccion: [],

  mostrarPacks: true,
  filtroTipoPack: [],
};

const prepareFiltros = function (filtros) {
  const filtrosPrivados = filtros.filter(
    (v) => "user_id" in v && v.user_id !== null
  );
  const filtrosPublicos = filtros.filter(
    (v) => "user_id" in v && v.user_id === null
  );

  let filtrosResult = [];
  if (filtrosPrivados.length) {
    filtrosResult.push({
      header: "Filtros privados",
    });
    filtrosResult.push(...filtrosPrivados);
  }
  if (filtrosPublicos.length) {
    if (filtrosPrivados.length)
      filtrosResult.push({
        divider: true,
      });
    filtrosResult.push({
      header: "Filtros públicos",
    });
    filtrosResult.push(...filtrosPublicos);
  }
  return filtrosResult;
};
const calcularFechasMes = function () {
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();
  let firstDay = new Date(year, month, 2).toISOString().split("T")[0];
  let lastDay = new Date(year, month + 1, 1).toISOString().split("T")[0];
  return [firstDay, lastDay];
};
export default {
  namespaced: true,
  state: {
    filtros: {
      ...defaultFilters,
    },
    filtrosActivos: {
      ...defaultFilters,
    },
    dialog: false,
    loading: false,
    agruparPor: {
      text: "Cliente",
      value: "cliente",
    },
    listaAcciones: [],
    loadingExport: false,

    plantillasFiltros: [],
    plantillaSeleccionada: undefined,
    loadingFiltrosListadoAcciones: false,
  },
  mutations: {
    UPDATE_FILTRO(state, { filtro, value }) {
      switch (filtro) {
        case "fechaInicio":
          if (value > state.filtros.fechaFin) state.filtros.fechaFin = null;
          break;
        case "fechaFin":
          if (value < state.filtros.fechaInicio)
            state.filtros.fechaInicio = null;
          break;
        default:
          break;
      }
      state.filtros[filtro] = value;

      state.plantillaSeleccionada = undefined;
    },
    REMOVE_FILTRO(state, { filtro, value }) {
      switch (filtro) {
        case "filtroTipoAccion":
        case "filtroTipoPack":
        case "filtroEstadoParte":
          let index = state.filtros[filtro].findIndex(function (k) {
            if (value.value === k.value) return true;
          });
          if (index != -1) {
            let deleted = state.filtros[filtro].splice(index, 1);
          }
          break;
        default:
          state.filtros[filtro] = null;
          break;
      }
      state.plantillaSeleccionada = undefined;
    },
    REMOVE_FILTROS(state, filtro) {
      switch (filtro.value) {
        case "filtroTipoAccion":
        case "bloqueadas":
          state.filtrosActivos.mostrarAcciones = defaultFilters.mostrarAcciones;
          break;
        case "filtroTipoPack":
          state.filtrosActivos.mostrarPacks = defaultFilters.mostrarPacks;
          // state.agruparPor = ''
          break;
        default:
          break;
      }
      state.filtrosActivos[filtro.value] = defaultFilters[filtro.value];
    },
    TOGGLE_DIALOG(state, applyFilters) {
      state.dialog = !state.dialog;
      if (state.dialog) {
        state.plantillaSeleccionada = undefined;
        state.filtros = {
          ...state.filtrosActivos,
        };
      } else {
        if (applyFilters)
          state.filtrosActivos = {
            ...state.filtros,
          };
      }
    },
    RESET_FILTERS(state) {
      state.filtrosActivos = state.filtros = defaultFilters;
      state.dialog = false;
      state.plantillaSeleccionada = undefined;
    },
    UPDATE_AGRUPAR_POR(state, value = "") {
      state.agruparPor = value;
      if (state.agruparPor && state.agruparPor.value == "tecnico") {
        state.filtrosActivos.mostrarPacks = false;
      } else state.filtrosActivos.mostrarPacks = true;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_EXPORT(state, value) {
      state.loadingExport = value;
    },
    SET_LISTA_ACCIONES(state, value) {
      state.listaAcciones = value;
    },
    SET_LOADING_FILTROS_LISTADO_ACCIONES(state, value) {
      state.loadingFiltrosListadoAcciones = value;
    },
    SET_PLANTILLA_FILTROS(state, value) {
      state.plantillasFiltros = value;
    },
    UPDATE_PLANTILLA_SELECCIONADA(state, value) {
      state.plantillaSeleccionada = value;

      if (value !== undefined) {
        const filtros = JSON.parse(state.plantillaSeleccionada.filtros);
        if (value.fechasDinamicas) {
          const [fechaInicio, fechaFin] = calcularFechasMes();
          filtros.fechaInicio = fechaInicio;
          filtros.fechaFin = fechaFin;
        }
        state.filtros = filtros;
      } else
        state.filtros = {
          ...defaultFilters,
        };
    },
    DELETE_FILTRO_LISTADO_ACCIONES(state, id) {
      const index = state.plantillasFiltros
        .map(function (item) {
          return item.id;
        })
        .indexOf(id);

      state.plantillasFiltros.splice(index, 1);

      state.plantillasFiltros = prepareFiltros(state.plantillasFiltros);
      if (state.plantillaSeleccionada && state.plantillaSeleccionada.id === id)
        state.plantillaSeleccionada = undefined;
    },
    // APLICAR_PLANTILLA(state) {
    //     const filtros = JSON.parse(state.plantillaSeleccionada.filtros)
    //     // state.filtrosActivos = filtros
    //     state.filtros = filtros
    // }
  },
  actions: {
    getListaAcciones({ state, commit, dispatch }) {
      commit("SET_LOADING", true);
      commit("SET_LISTA_ACCIONES", []);
      let queryParams = {
        fechaInicio: state.filtrosActivos.fechaInicio,
        fechaFin: state.filtrosActivos.fechaFin,
        cliente_id: state.filtrosActivos.clienteSeleccionado
          ? state.filtrosActivos.clienteSeleccionado.value
          : null,
        tecnico_id: state.filtrosActivos.tecnicoSeleccionado
          ? state.filtrosActivos.tecnicoSeleccionado.id
          : null,
        // contrato_id: filtros.contrato_id ? filtros.contrato_id : null,
        bloqueadas: state.filtrosActivos.bloqueadas ? 1 : 0,
      };
      axios
        .get("api/listadoacciones", {
          params: queryParams,
        })
        .then((res) => {
          commit("SET_LISTA_ACCIONES", res.data);
        })
        .catch((err) => {
          console.log(err);
          dispatch(
            "setSnackbar",
            {
              tipo: "error",
              mensaje:
                "Error. No se ha podido recuperar el listado de acciones.",
            },
            {
              root: true,
            }
          );
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    isAccionFiltradaPorTipoPack({ state }, accion) {
      if (!state.filtrosActivos.mostrarPacks) return true;
      if (!state.filtrosActivos.filtroTipoPack.length) return false;
      return !state.filtrosActivos.filtroTipoPack.some(
        (elem) => elem.value === accion.contrato_id
      );
    },
    isAccionFiltradaPorTipoAccion({ state }, accion) {
      if (!state.filtrosActivos.mostrarAcciones) return true;
      if (!state.filtrosActivos.filtroTipoAccion.length) return false;
      return !state.filtrosActivos.filtroTipoAccion.some(
        (elem) => elem.value === accion.contrato_id
      );
    },
    isAccionFiltradaPorEstadoParte({ state }, accion) {
      if (!state.filtrosActivos.filtroEstadoParte.length) return false;
      return !state.filtrosActivos.filtroEstadoParte.some(
        (elem) => elem.value === accion.estadoParte_id
      );
    },
    imprimirListado({ commit, dispatch, state }, { type, acciones }) {
      if (!acciones.length)
        dispatch(
          "setSnackbar",
          {
            tipo: "info",
            mensaje: "Selecciona por lo menos un registro para exportar.",
          },
          {
            root: true,
          }
        );
      else {
        commit("SET_LOADING_EXPORT", true);
        const accionRegexp = /^p\d+/; //empieza por p
        const packRegexp = /^d\d+/; //empieza por d

        let request = {
          acciones: acciones
            .filter((accion) => accionRegexp.test(accion.id))
            .map((accion) => {
              return {
                id: accion.id.replace("p", ""),
              };
            }),
          packs: acciones
            .filter((accion) => packRegexp.test(accion.id))
            .map((accion) => {
              return {
                id: accion.id.replace("d", ""),
              };
            }),
          filtros: {
            fechaInicio: formatearFecha.methods.formatDate(
              state.filtrosActivos.fechaInicio
            ),
            fechaFin: formatearFecha.methods.formatDate(
              state.filtrosActivos.fechaFin
            ),
            cliente: state.filtrosActivos.clienteSeleccionado,
            tecnico: state.filtrosActivos.tecnicoSeleccionado,
            estadosParte: state.filtrosActivos.filtroEstadoParte,
            tiposAccion: state.filtrosActivos.filtroTipoAccion,
            tiposContrato: state.filtrosActivos.filtroTipoPack,
            bloqueadas: state.filtrosActivos.bloqueadas,
          },
          agruparPor: state.agruparPor,
        };
        return axios
          .post("api/informelistadoacciones", request, {
            params: {
              tipo: type,
            },
            responseType: "blob",
          })
          .then((response) => {
            // const link = document.createElement("a");
            // link.href = window.URL.createObjectURL(new Blob([response.data]));
            // if (type.toLowerCase() == "excel") {
            //     link.setAttribute("download", "listadoAcciones.xlsx");
            // } else {
            //     link.setAttribute("download", "listadoAcciones.pdf");
            // }
            // document.body.appendChild(link);
            // link.click();
            // dispatch('setSnackbar', {
            //     tipo: "success",
            //     mensaje: `Informe ${type} descargado correctamente.`,
            // }, {
            //     root: true
            // })
            dispatch(
              "informe/download",
              {
                response: response,
                type: type,
                name: "listadoAcciones",
              },
              {
                root: true,
              }
            );
          })
          .catch((error) => {
            let errorMessage = error.response
              ? error.response.data
              : error.request
              ? error.request
              : error.message;
            dispatch(
              "setSnackbar",
              {
                tipo: "error",
                mensaje: `${errorMessage}`,
              },
              {
                root: true,
              }
            );
          })
          .finally(() => {
            commit("SET_LOADING_EXPORT", false);
          });
      }
    },
    getFiltrosListadoAcciones({ commit, dispatch }) {
      commit("SET_LOADING_FILTROS_LISTADO_ACCIONES", true);
      axios
        .get("api/filtrosListadoAcciones")
        .then((res) => {
          const filtros = prepareFiltros(res.data);
          commit("SET_PLANTILLA_FILTROS", filtros);
        })
        .catch((err) => {
          dispatch(
            "setSnackbar",
            {
              tipo: "error",
              mensaje:
                "Error. No se han podido recuperar los filtros guardados.",
            },
            {
              root: true,
            }
          );
        })
        .finally(() => commit("SET_LOADING_FILTROS_LISTADO_ACCIONES", false));
    },
    deleteFiltroListadoAcciones({ commit, dispatch }, id) {
      commit("SET_LOADING_FILTROS_LISTADO_ACCIONES", true);
      axios
        .delete(`api/filtrosListadoAcciones/${id}`)
        .then(() => {
          dispatch(
            "setSnackbar",
            {
              tipo: "success",
              mensaje: "Filtro eliminado correctamente.",
            },
            {
              root: true,
            }
          );
          commit("DELETE_FILTRO_LISTADO_ACCIONES", id);
        })
        .catch((err) => {
          console.log(err);
          dispatch(
            "setSnackbar",
            {
              tipo: "error",
              mensaje: "Error. No se ha podido eliminar el filtro.",
            },
            {
              root: true,
            }
          );
        })
        .finally(() => {
          commit("SET_LOADING_FILTROS_LISTADO_ACCIONES", false);
        });
    },
    guardarFiltro({ dispatch, state }, filtro) {
      return axios
        .post("api/filtrosListadoAcciones", {
          ...filtro,
          filtros: JSON.stringify(state.filtros),
        })
        .then(() => {
          dispatch("getFiltrosListadoAcciones");
          dispatch(
            "setSnackbar",
            {
              tipo: "success",
              mensaje: "Plantilla guardada correctamente.",
            },
            {
              root: true,
            }
          );
        })
        .catch((err) => {
          dispatch(
            "setSnackbar",
            {
              tipo: "error",
              mensaje: "Error. No se ha podido guardar el filtro.",
            },
            {
              root: true,
            }
          );
        });
    },
  },
  getters: {
    filtrosActivos: (state) => {
      let filtros = [
        {
          value: "fechaInicio",
          text: state.filtrosActivos.fechaInicio
            ? `Fecha ini.: ${formatearFecha.methods.formatDate(
                state.filtrosActivos.fechaInicio
              )}`
            : null,
          color: "primary",
        },
        {
          value: "fechaFin",
          text: state.filtrosActivos.fechaFin
            ? `Fecha fin: ${formatearFecha.methods.formatDate(
                state.filtrosActivos.fechaFin
              )}`
            : null,
          color: "primary",
        },
        {
          value: "clienteSeleccionado",
          text: state.filtrosActivos.clienteSeleccionado
            ? state.filtrosActivos.clienteSeleccionado.text.length > 30
              ? `${state.filtrosActivos.clienteSeleccionado.text.substring(
                  0,
                  30
                )}...`
              : state.filtrosActivos.clienteSeleccionado.text
            : null,
          color: "primary",
        },
        {
          value: "tecnicoSeleccionado",
          text: state.filtrosActivos.tecnicoSeleccionado
            ? state.filtrosActivos.tecnicoSeleccionado.nombre
            : null,
          color: "primary",
        },
        {
          value: "filtroEstadoParte",
          text: state.filtrosActivos.filtroEstadoParte.length
            ? "Estado del parte"
            : null,
          color: "primary",
        },
        {
          value: "filtroTipoAccion",
          text: !state.filtrosActivos.mostrarAcciones
            ? "Ocultando acciones"
            : state.filtrosActivos.filtroTipoAccion.length
            ? "Tipo de acción"
            : null,
          color: !state.filtrosActivos.mostrarAcciones ? "error" : "primary",
        },
        {
          value: "filtroTipoPack",
          text: !state.filtrosActivos.mostrarPacks
            ? "Ocultando packs"
            : state.filtrosActivos.filtroTipoPack.length
            ? "Tipo de pack/tramo"
            : null,
          color: !state.filtrosActivos.mostrarPacks ? "error" : "primary",
        },
        {
          value: "bloqueadas",
          text: !state.filtrosActivos.mostrarAcciones
            ? null
            : state.filtrosActivos.bloqueadas
            ? "Acciones cerradas"
            : "Acciones activas",
          color: state.filtrosActivos.bloqueadas ? "error" : "primary",
        },
      ];
      return filtros.filter((item) => item.text != null);
    },

    listaAcciones: (state) =>
      state.listaAcciones
        .filter((item) => {
          const cliente =
            !state.filtrosActivos.clienteSeleccionado ||
            state.filtrosActivos.clienteSeleccionado.value === item.cliente_id;

          if (item.estadoParte_id === null) {
            //es un pack
            const tipoPack =
              !state.filtrosActivos.filtroTipoPack.length ||
              state.filtrosActivos.filtroTipoPack.some(
                (filtro) => filtro.value === item.contrato_id
              );
            if (state.filtrosActivos.mostrarPacks && tipoPack && cliente)
              return item;
          } else {
            //es una accion
            const tecnico =
              !state.filtrosActivos.tecnicoSeleccionado ||
              state.filtrosActivos.tecnicoSeleccionado.id === item.tecnico_id;
            const tipoAccion =
              !state.filtrosActivos.filtroTipoAccion.length ||
              state.filtrosActivos.filtroTipoAccion.some(
                (elem) => elem.value === item.contrato_id
              );
            const estado =
              !state.filtrosActivos.filtroEstadoParte.length ||
              state.filtrosActivos.filtroEstadoParte.some(
                (elem) => elem.value === item.estadoParte_id
              );
            if (
              state.filtrosActivos.mostrarAcciones &&
              tipoAccion &&
              estado &&
              cliente &&
              tecnico
            )
              return item;
          }
        })
        .map((accion) => {
          accion.fecha = formatearFecha.methods.crearFecha(
            "d/m/Y",
            accion.fecha
          );
          return accion;
        }),
    headers: (state) => [
      {
        text: "Cliente",
        align: "start",
        filterable: true,
        sortable: true,
        value: "cliente",
      },
      {
        text: "Parte",
        align: "start",
        filterable: true,
        sortable: true,
        value: "parte",
      },
      {
        text: "Técnico",
        align: "start",
        filterable: true,
        sortable: true,
        value: "tecnico",
      },
      {
        text: "Contrato",
        align: "start",
        filterable: true,
        sortable: true,
        value: "contrato",
      },
      {
        text: "Fecha",
        align: "start",
        filterable: true,
        sortable: true,
        value: "fecha",
        groupable: false,
      },
      {
        text: "Horas",
        align: "start",
        filterable: true,
        sortable: true,
        value: "horasReales",
        groupable: false,
      },
      {
        text:
          state.agruparPor && state.agruparPor.value === "tecnico"
            ? "Horas bonus"
            : "Horas ponderadas",
        align: "start",
        filterable: true,
        sortable: true,
        value:
          state.agruparPor && state.agruparPor.value === "tecnico"
            ? "horasBonus"
            : "horasPonderadas",
        groupable: false,
        visible: false,
        meta: "horasCalculadas",
      },
      {
        text: "",
        value: "data-table-expand",
      },
    ],
    //NO SE SI ESTA O DIRECTAMENTE EN CONTAINER
    // getGroupLength: (state, getters) => (groupBy, group) => {
    //     return getters.listaAcciones.filter((item) => item[groupBy] === group).length
    // },
    //NO SE SI ESTA O DIRECTAMENTE EN CONTAINER
    // sumGroupProperty: (state, getters) => (groupBy, group, prop) => {
    //     // console.log(getters.headers);
    //     const h = getters.headers.find((elem) => elem.hasOwnProperty("meta") && elem.meta === prop);
    //     if (h !== undefined) prop = h.value;
    //     return (Math.round(getters.listaAcciones.filter((item) => item[groupBy] === group).reduce(function (a, b) {
    //         return a + b[prop];
    //     }, 0) * 100) / 100)
    // },
    bloqueadas: (state) => state.filtrosActivos.bloqueadas,
    fechaInicio: (state) => state.filtrosActivos.fechaInicio,
    fechaFin: (state) => state.filtrosActivos.fechaFin,
    clienteSeleccionado: (state) => state.filtrosActivos.clienteSeleccionado,
    tecnicoSeleccionado: (state) => state.filtrosActivos.tecnicoSeleccionado,
    loadingExport: (state) => state.loadingExport,
  },
};
